export default __webpack_public_path__ + "0bbc195dce62f48f39c5739c86249303.png";